export default __webpack_public_path__ + "static/media/PlusSingle.070f6d3b.svg";